import { GRNStatus } from 'src/models/enums/GRNStatus.enum';
import { userRoles } from './properties.utils';

export interface GRNPermissions {
  canView: boolean;
  canEdit: boolean;
  canUpdateStatus: boolean;
  canDelete: boolean;
  canCreatePayment: boolean;
  canPrint: boolean;
}

export const getGRNPermissions = (
  userRole: string,
  status: GRNStatus
): GRNPermissions => {
  const normalizedRole = userRole?.toLowerCase()?.trim() || '';

  const isAdminOrOwner =
    normalizedRole === userRoles.ADMIN.toLowerCase() ||
    normalizedRole === userRoles.OWNER.toLowerCase();
  const isFactoryManagerOrExecutive =
    normalizedRole === userRoles.FACTORY_MANAGER.toLowerCase() ||
    normalizedRole === userRoles.EXECUTIVE.toLowerCase();

  const canEdit =
    (isAdminOrOwner || isFactoryManagerOrExecutive) &&
    (status === GRNStatus.NEW || status === GRNStatus.PENDING);

  const canDelete = status === GRNStatus.NEW || status === GRNStatus.PENDING;

  const canPrint =
    (isAdminOrOwner || isFactoryManagerOrExecutive) &&
    (status === GRNStatus.APPROVED || status === GRNStatus.REJECTED);

  const permissions = {
    canView: true,
    canEdit,
    canUpdateStatus: isAdminOrOwner && status === GRNStatus.PENDING,
    canDelete,
    canCreatePayment:
      (isAdminOrOwner || isFactoryManagerOrExecutive) &&
      (status === GRNStatus.APPROVED ||
        status === GRNStatus.PAYMENT_PROGRESS ||
        status === GRNStatus.PAID),
    canPrint,
  };

  return permissions;
};
